import { useCallback } from "react";
import api, { openApi } from "../../services/api";

const useSettings = () => {
  const getAll = useCallback(async (params) => {
    try {
      const { data } = await api.get("/settings", params);
      return Array.isArray(data) ? data : (data?.settings || []);
    } catch (error) {
      console.warn('Failed to get settings:', error);
      return [];
    }
  }, []);

  const update = useCallback(async (data) => {
    console.log(`\n========================================`);
    console.log(`🔧 [HOOK] useSettings.update CHAMADO`);
    console.log(`========================================`);
    console.log(`📝 [HOOK] Parâmetros recebidos:`, data);
    console.log(`📝 [HOOK] Key: ${data?.key}`);
    console.log(`📝 [HOOK] Value: ${JSON.stringify(data?.value)}`);
    console.log(`📝 [HOOK] Value Type: ${typeof data?.value}`);
    console.log(`📝 [HOOK] Timestamp: ${new Date().toISOString()}`);
    
    // Validação de parâmetros
    if (!data || !data.key) {
      console.error(`❌ [HOOK] ERRO DE VALIDAÇÃO: Key não fornecida`);
      console.error(`❌ [HOOK] Data recebido:`, data);
      throw new Error("Key é obrigatória para atualizar configuração");
    }
    
    if (data.value === undefined) {
      console.warn(`⚠️ [HOOK] ATENÇÃO: Value é undefined`);
    }
    
    // Tratamento especial para valores booleanos - converter para string antes de enviar
    const valueToSend = typeof data.value === 'boolean' ? String(data.value) : data.value;
    console.log(`📝 [HOOK] Value após tratamento: ${JSON.stringify(valueToSend)} (tipo: ${typeof valueToSend})`);
    
    console.log(`✅ [HOOK] Validação de parâmetros OK`);
    
    try {
      console.log(`\n📤 [HOOK] ENVIANDO REQUISIÇÃO HTTP`);
      console.log(`📤 [HOOK] Method: PUT`);
      console.log(`📤 [HOOK] URL: /settings/${data.key}`);
      console.log(`📤 [HOOK] Body:`, { ...data, value: valueToSend });
      console.log(`📤 [HOOK] Aguardando resposta...`);
      
      const startTime = Date.now();
      const response = await api.put(
        `/settings/${data.key}`,
        { ...data, value: valueToSend },
      );
      const endTime = Date.now();
      const duration = endTime - startTime;
      
      console.log(`\n📥 [HOOK] RESPOSTA HTTP RECEBIDA`);
      console.log(`📥 [HOOK] Duração da requisição: ${duration}ms`);
      console.log(`📥 [HOOK] Status: ${response?.status}`);
      console.log(`📥 [HOOK] Status Text: ${response?.statusText}`);
      console.log(`📥 [HOOK] Headers:`, response?.headers);
      console.log(`📥 [HOOK] Response completo:`, response);
      console.log(`📥 [HOOK] Response.data:`, response.data);
      
      // Validar estrutura da resposta
      if (!response.data) {
        console.error(`❌ [HOOK] ERRO: Response.data está vazio ou undefined`);
        console.error(`❌ [HOOK] Response completo:`, response);
        throw new Error("Resposta da API não contém dados");
      }
      
      console.log(`\n✅ [HOOK] VALIDANDO RESPOSTA`);
      console.log(`✅ [HOOK] Response.data.id: ${response.data.id}`);
      console.log(`✅ [HOOK] Response.data.key: ${response.data.key}`);
      console.log(`✅ [HOOK] Response.data.value: ${JSON.stringify(response.data.value)}`);
      console.log(`✅ [HOOK] Response.data.companyId: ${response.data.companyId}`);
      console.log(`✅ [HOOK] Response.data.updatedAt: ${response.data.updatedAt}`);
      
      // Verificar se o valor retornado corresponde ao enviado
      if (response.data.value !== valueToSend) {
        console.warn(`⚠️ [HOOK] ATENÇÃO: Valor retornado difere do enviado!`);
        console.warn(`⚠️ [HOOK] Enviado: ${JSON.stringify(valueToSend)}`);
        console.warn(`⚠️ [HOOK] Retornado: ${JSON.stringify(response.data.value)}`);
      } else {
        console.log(`✅ [HOOK] Valor retornado corresponde ao enviado`);
      }
      
      console.log(`\n✅ [HOOK] REQUISIÇÃO CONCLUÍDA COM SUCESSO`);
      console.log(`========================================\n`);
      
      return response.data;
    } catch (error) {
      console.error(`\n❌ [HOOK] ERRO NA REQUISIÇÃO HTTP`);
      console.error(`========================================`);
      console.error(`❌ [HOOK] Key: ${data?.key}`);
      console.error(`❌ [HOOK] Value: ${JSON.stringify(data?.value)}`);
      console.error(`❌ [HOOK] Value (tratado): ${JSON.stringify(valueToSend)}`);
      console.error(`❌ [HOOK] Error object:`, error);
      console.error(`❌ [HOOK] Error message:`, error?.message);
      console.error(`❌ [HOOK] Error name:`, error?.name);
      
      if (error?.response) {
        console.error(`\n❌ [HOOK] HTTP ERROR RESPONSE`);
        console.error(`❌ [HOOK] Status: ${error.response.status}`);
        console.error(`❌ [HOOK] Status Text: ${error.response.statusText}`);
        console.error(`❌ [HOOK] Data:`, error.response.data);
        console.error(`❌ [HOOK] Headers:`, error.response.headers);
        
        if (error.response.status === 401) {
          console.error(`❌ [HOOK] ERRO DE AUTENTICAÇÃO - Token inválido ou expirado`);
        } else if (error.response.status === 403) {
          console.error(`❌ [HOOK] ERRO DE PERMISSÃO - Usuário não tem permissão`);
        } else if (error.response.status === 404) {
          console.error(`❌ [HOOK] ERRO 404 - Endpoint não encontrado`);
        } else if (error.response.status >= 500) {
          console.error(`❌ [HOOK] ERRO DO SERVIDOR - Problema no backend`);
        }
      } else if (error?.request) {
        console.error(`\n❌ [HOOK] NETWORK ERROR`);
        console.error(`❌ [HOOK] Nenhuma resposta recebida do servidor`);
        console.error(`❌ [HOOK] Possíveis causas:`);
        console.error(`   - Servidor offline`);
        console.error(`   - Problema de rede`);
        console.error(`   - CORS bloqueado`);
        console.error(`   - Timeout`);
        console.error(`❌ [HOOK] Request:`, error.request);
      } else {
        console.error(`\n❌ [HOOK] ERRO DESCONHECIDO`);
        console.error(`❌ [HOOK] Erro ao configurar requisição`);
        console.error(`❌ [HOOK] Stack trace:`, error?.stack);
      }
      
      console.error(`========================================\n`);
      throw error;
    }
  }, []);

  const get = useCallback(async (param) => {
    const { data } = await api.get(
      `/setting/${param}`,
    );
    return data;
  }, []);

  const getPublicSetting = useCallback(async (key, companyId = null) => {
    try {
      const params = companyId ? { companyId } : {};
      const { data } = await openApi.get(
        `/public-settings/${key}`,
        params,
      );
      return data || null;
    } catch (error) {
      console.warn(`Failed to get public setting '${key}':`, error);
      return null;
    }
  }, []);

  return {
    getAll,
    update,
    get,
    getPublicSetting,
  };
};

export default useSettings;
